(function () {
  var HUE_PRODUCT_ID = "hppy-homepage-module";

  var TARGET_ID = "shopify-section-template--26296259346799__multi_column_8yFqcm";

  function createHueSection() {
    var section = document.createElement("section");
    section.className = "container section-spacing";
    section.setAttribute("data-hue-mini-review-home", "");

    var mount = document.createElement("div");
    mount.id = "hue-mini-review-module";
    mount.className = "hue-module";
    mount.setAttribute("data-product-id", HUE_PRODUCT_ID);

    section.appendChild(mount);
    return section;
  }

  function replaceOnce() {
    if (document.querySelector("[data-hue-mini-review-home]")) return true;

    var target = document.getElementById(TARGET_ID);
    if (!target) return false;

    var hueSection = createHueSection();
    target.parentNode.replaceChild(hueSection, target);

    document.dispatchEvent(new CustomEvent("hue-mini-home-mounted", { bubbles: true }));
    return true;
  }

  function boot() {
    if (replaceOnce()) return;

    var obs = new MutationObserver(function () {
      if (replaceOnce()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    setTimeout(function () {
      try { obs.disconnect(); } catch (e) {}
    }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

(function () {
  document.addEventListener(
   'hue-add-to-cart',
   (e) => {
     // ADDS TO CART
     const formData = new FormData()
     formData.append('id', e.detail.variantId)
     formData.append('quantity', 1)
     formData.append('sections', 'cart,cart-count')
     fetch(window.Shopify.routes.root + "cart/add.js", {
       method: "POST",
       body: formData,
     })
       .then(e => e.json())
       .then(e => {
         // FINDS THE CART BUTTON AND CLICKS IT TO OPEN THE CART
         let element = document.querySelector("a[href='/cart']");
         element.click();

         // TELLS THE CART TO REFRESH WITH THE RESULTS OF THE ADD
         // SO THE USER WILL SEE THE ITEM THEY JUST ADDED IN THE CART
         document.dispatchEvent(new CustomEvent('cart:build' , {
           bubbles: true
         }));
         document.dispatchEvent(new CustomEvent('cart:refresh', {
           bubbles: true,
           detail: e
         }));
       })
   }
 )
})()
